import { render, staticRenderFns } from "./ChatAsside.vue?vue&type=template&id=36c13d26&"
import script from "./ChatAsside.vue?vue&type=script&lang=js&"
export * from "./ChatAsside.vue?vue&type=script&lang=js&"
import style0 from "./ChatAsside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VDivider,VList,VListItemGroup})
